import { useSignedDocumentUrl } from '../../hooks/useSignedDocumentUrl';

interface SocialPostImageProps {
  /** Storage key (from server upload) or URL (blob/http). Keys are resolved to signed URLs. */
  src: string | undefined | null;
  alt?: string;
  className?: string;
}

/**
 * Renders a post image. If src is a storage key (not http/blob), resolves it to a signed URL for display.
 */
export function SocialPostImage({
  src,
  alt = '',
  className,
}: SocialPostImageProps) {
  const { url, loading } = useSignedDocumentUrl(src);

  if (!src) return null;
  if (loading || !url) {
    return (
      <div
        className={className}
        style={{
          backgroundColor: 'var(--feed-bg, #F0EFF5)',
          minHeight: 200,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="text-[#464452] dark:text-white/50 text-sm">
          Loading…
        </span>
      </div>
    );
  }
  return <img src={url} alt={alt} className={className} />;
}
